import {AxiosResponse} from "axios";

import CoreApi from "@/src/modules/core/api";
import {axios, getParams} from "@/src/modules/core/lib";
import type {GetListResponse, GetResponse, ParamsOptions} from "@/src/modules/core/types";

import type {
  CorrectSafelistingRequest,
  CreateSafelistingRequest,
  ModifyDaysRequest,
  Safelisting,
  UpdateSafelistingRequest,
} from "../types";

class SafelistingsApi extends CoreApi {
  createSafelisting(
    data: CreateSafelistingRequest,
  ): Promise<AxiosResponse<GetResponse<Safelisting>>> {
    return super.create("safelisting", data);
  }

  updateSafelisting(
    id: number,
    data: UpdateSafelistingRequest,
  ): Promise<AxiosResponse<GetResponse<Safelisting>>> {
    return super.update("safelisting", id, data);
  }

  getSafelistings(options: ParamsOptions): Promise<AxiosResponse<GetListResponse<Safelisting>>> {
    return super.search("safelisting", options);
  }

  getSafelisting(id: number): Promise<AxiosResponse<GetResponse<Safelisting>>> {
    return super.getById("safelisting", id);
  }

  deleteSafelisting(id: number): Promise<AxiosResponse<void>> {
    return super.delete("safelisting", id);
  }

  cancelSafelisting(id: number): Promise<AxiosResponse<GetResponse<Safelisting>>> {
    return super.post(`safelisting/${id}/cancel`, {});
  }

  correctSafelisting(
    id: number,
    data: CorrectSafelistingRequest,
  ): Promise<AxiosResponse<GetResponse<Safelisting>>> {
    return super.post(`safelisting/${id}/correct`, data);
  }

  modifyDays(
    id: number,
    data: ModifyDaysRequest,
  ): Promise<AxiosResponse<GetResponse<Safelisting>>> {
    return axios({
      url: `safelisting/${id}/modify-days`,
      method: "patch",
      data,
    });
  }

  getQrCode(id: number): Promise<AxiosResponse<GetResponse<unknown>>> {
    return this.get(`safelisting/${id}/qr-code`);
  }

  getAvailability(options?: ParamsOptions): Promise<AxiosResponse<GetResponse<unknown>>> {
    const params = getParams(options);
    return axios({url: "safelistings/availability", method: "get", params});
  }

  getAccountability(options?: ParamsOptions): Promise<AxiosResponse<GetResponse<unknown>>> {
    const params = getParams(options);
    return axios({url: "safelistings/accountability", method: "get", params});
  }

  getHistory(options?: ParamsOptions): Promise<AxiosResponse<GetResponse<unknown>>> {
    const params = getParams(options);
    return axios({url: "safelistings/history", method: "get", params});
  }
}

export const safelistingsApi = new SafelistingsApi();
